// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"7":"ProfilePage","78":"AttachmentsPage","423":"WorkspacePage","518":"ScansPage","703":"HomePage","810":"NotFound"}[chunkId] || chunkId) + "." + {"7":"6b983dfd","78":"577ece05","423":"0a999211","518":"7224886b","703":"dee22f1a","810":"1c9fc34b","832":"80fd6c16"}[chunkId] + ".chunk.js";
};